<template>
  <div id="app">
    <Mobile v-if="isMobile" />
    <Main v-else />
  </div>
</template>

<script>
import Main from "@/views/main";
import Mobile from "@/views/mobile";
export default {
  name: "App",
  components: {
    Main,
    Mobile,
  },
  data() {
    return {
      isMobile: false,
    };
  },
  created() {
    this.isMobile = window.navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    ); // 是否手机端
  },
};
</script>

<style lang="less">
#app {
  height: 100%;
}
</style>
